export default __webpack_public_path__ + "static/1990_2000-54b21c7f58b782662baa56f60d238506.jpg";